module.exports = __webpack_public_path__ + "img/gooddoc.6abcc59e.png";